/**
 * Toggle Current Navi Item
 *
 * 表示中のコンテンツに対応したナビゲーションの切り替え
 * @param {string} [activeClass='current'] - ナビゲーションに追加するクラス名
 */
export function toggleCurrentNavItem(activeClass = 'current') {
	// data-navi-item 属性を持つナビゲーション要素を取得
	const naviItems = Array.from(document.querySelectorAll('[data-navi-item]'));
	const naviTargets = {};

	// data-navi-item に対応する id を持つ要素を取得してキャッシュ
	naviItems.forEach(naviItem => {
		const targetId = naviItem.dataset.naviItem;
		const targetElement = document.getElementById(targetId);
		if (targetElement) {
			naviTargets[targetId] = {
				naviItem,
				targetElement
			};
		}
	});

	// スクロールイベントの処理
	const onScroll = () => {
		Object.values(naviTargets).forEach(({ naviItem, targetElement }) => {
			const rect = targetElement.getBoundingClientRect();
			const isInViewport = rect.top < window.innerHeight / 2 && rect.bottom > window.innerHeight / 2;

			if (isInViewport) {
				naviItem.classList.add(activeClass);
				naviItem.setAttribute('aria-current', 'true');
			} else {
				naviItem.classList.remove(activeClass);
				naviItem.removeAttribute('aria-current');
			}
		});
	};

	// スクロールイベントに requestAnimationFrame を使用して最適化
	let isScrolling = false;
	window.addEventListener('scroll', () => {
		if (!isScrolling) {
			isScrolling = true;
			requestAnimationFrame(() => {
				onScroll();
				isScrolling = false;
			});
		}
	});

	// 初回実行（読み込み時）
	onScroll();
}
